import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "rustem_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

// Public APIs
export const submitSimpleLead = async (data) => {
  const res = await axios.post(`${API}/leads/simple`, data);
  return res.data;
};

export const submitDetailedLead = async (data) => {
  const res = await axios.post(`${API}/leads/detailed`, data);
  return res.data;
};

// Admin APIs
export const adminLogin = async (password) => {
  const res = await axios.post(`${API}/admin/login`, { password });
  return res.data;
};

const authHeaders = () => ({
  headers: { Authorization: `Bearer ${getToken()}` },
});

export const fetchLeads = async (statusFilter = "all", typeFilter = "all") => {
  const params = {};
  if (statusFilter !== "all") params.status = statusFilter;
  if (typeFilter !== "all") params.type_filter = typeFilter;
  const res = await axios.get(`${API}/admin/leads`, {
    ...authHeaders(),
    params,
  });
  return res.data;
};

export const updateLead = async (id, updates) => {
  const res = await axios.patch(`${API}/admin/leads/${id}`, updates, authHeaders());
  return res.data;
};

export const deleteLead = async (id) => {
  const res = await axios.delete(`${API}/admin/leads/${id}`, authHeaders());
  return res.data;
};

export const exportLeadsCSV = () => {
  return `${API}/admin/leads/export`;
};
